<div
  class="input-wrapper"
  [class.invalid]="hasErrors"
  [class.error]="shouldPrintError"
  [class.row]="rowStyle"
>
  @if (label) {
    <label>
      <span class="label-content">
        {{ label }}
        <span *ngIf="requiredMarker" class="required-marker">{{
          requiredMarker
        }}</span>
        <i
          *ngIf="hint"
          [matTooltip]="hint"
          matTooltipPosition="right"
          class="tooltip-icon"
          >i</i
        >
      </span>

      <span class="end">
        <ng-content select="[input-wrapper-end]"></ng-content>
      </span>
    </label>
  }
  <div class="flex">
    <span class="input-icon input-icon--start">
      <ng-content select="[input-wrapper-icon-start]"></ng-content>
    </span>
    <ng-content></ng-content>
    @if (isSelect) {
      <span class="input-icon input-icon--end">
        <app-icon name="ic_chevron_down" />
      </span>
    }
    @if (unit) {
      <span>{{ unit }}</span>
    }
  </div>
  @for (e of renderErrors; track e.message) {
    <p class="error-wrapper">{{ e.message }}</p>
  }
</div>
